import ShareViaDialog from './ShareViaDialog';

// @ts-expect-error no types
import ControlsProvider from '../../shareAsset/context';
// @ts-expect-error no types
import { useUserRoleForReport } from '../../../utils/trackingUtils';
// @ts-expect-error no types
import { getDefaultSavedReportActionEventProperties } from '../../report-action-wrapper';
// @ts-expect-error no types
import { getId, getName } from '../../../data/schemas/reportSchema';
import { REPORT_OBJECT_TYPE } from 'dashboard-lib/public/emails/emails';
import { ShareViaSettingsProvider } from './ShareViaSettingsContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareViaDialogContainer = ({
  appUsageTracker,
  report,
  scheduledSharedAsset
}) => {
  const userRole = useUserRoleForReport(report);
  return /*#__PURE__*/_jsx(ControlsProvider, {
    scheduledSharedAsset: scheduledSharedAsset,
    appUsageTracker: appUsageTracker,
    assetSpecificTrackingProps: Object.assign({}, getDefaultSavedReportActionEventProperties(report), {
      role: userRole
    }),
    assetName: getName(report),
    reportId: getId(report),
    objectType: REPORT_OBJECT_TYPE,
    report: report,
    children: /*#__PURE__*/_jsx(ShareViaSettingsProvider, {
      children: /*#__PURE__*/_jsx(ShareViaDialog, {})
    })
  });
};
export default ShareViaDialogContainer;